import { useMemo } from 'react';
import { useQueryParamHelper } from '@shared/core/queryString';
import { BOOKING_ENTRY_POINT_PARAM, BOOKING_PURPOSE_PARAM, TRIP_BOARD_PARAM, TRIP_SAVE_PARAM, toBookingContextParams } from '@shared/constants/bookingContext';
import type { BookingContextParams } from '@shared/constants/bookingContext.types';

/**
 * The current URL's booking context (TRAV-5008), ready to spread onto the next URL: every hop between
 * the surface that set it and the reservation create carries it forward, as `prioritizeTag` is carried.
 * Unknown values and absent params are omitted, so spreading this never writes an empty or forged value.
 */
export const useBookingContextParams = (): BookingContextParams => {
  const queryParamHelper = useQueryParamHelper();
  const bookingPurpose = queryParamHelper.getValueString(BOOKING_PURPOSE_PARAM);
  const bookingEntryPoint = queryParamHelper.getValueString(BOOKING_ENTRY_POINT_PARAM);
  const tripBoardId = queryParamHelper.getValueString(TRIP_BOARD_PARAM);
  const tripSaveId = queryParamHelper.getValueString(TRIP_SAVE_PARAM);
  return useMemo(
    () => toBookingContextParams(bookingPurpose, bookingEntryPoint, { boardId: tripBoardId, tripSaveId }),
    [bookingPurpose, bookingEntryPoint, tripBoardId, tripSaveId],
  );
};
